import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const LEContactAgency = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.leContactAgency"
      control={control}
      render={({ field }) => (
        <FF2 label="89. LE contact agency" field={field} input={(props) => <TextInput {...props} />} />
      )}
    />
  )
}
